import React from 'react'

type TextAreaProps = {
  value: string | boolean | number
  onChange: (value: any) => void
  className?: string
}

export default function TextArea(props: TextAreaProps & {[k: string]: any}) {
  const {value, onChange, ...additionalProps} = props
  const type = additionalProps.type || 'text'
  const valueName: any = {
    checkbox: 'checked',
  }
  const valueSelector = valueName[type] ?? 'value'
  const textareaProps = {
    [valueSelector]: value,
  }

  return (
    <textarea
      {...textareaProps}
      onChange={(event) => {
        onChange((event.target as any)[valueSelector])
      }}
      {...additionalProps}
    />
  )
}
